import UpdateEvent from "../components/events/updateEvent/index";
import Nav from "../components/Nav/nav";

const ProfPage = () => {
  return (
    <div>
      <Nav />
      <UpdateEvent />
    </div>
  );
};

export default ProfPage;
